export const API_BASE_URL =
    process.env.NODE_ENV === "development"
        ? "http://localhost:5000/api"
        : "https://app.selbst-vermarkten.de/api";
export const AWS_BASE_URL = "https://homesy.s3.eu-central-1.amazonaws.com/";
// export const API_BASE_URL = "https://test-api.homesy.de/api";

// export const  API_BASE_URL = "http://127.0.0.1:8000/api";
